
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class TopNav extends Vue {
  @Prop() private msg!: string;

  get isAuthenticated(): boolean {
    return this.$store.getters.isAuthenticated
  }

  logout() {
    this.$store.commit('setAuthenticationStatus', false)
    this.$store.commit('setUsername', '')
    this.$store.commit('setPassword', '')
    this.$router.push({name: 'Login'})
  }
}
